import React, { FunctionComponent } from 'react';

import { ReactComponent as EditSvgIcon } from '../../../assets/icons/icon_edit.svg';
import {ClassBuilder} from 'b302-frontend-library';

interface Props {
    onClick?: () => void;
    className?: string;
}

const EditIcon: FunctionComponent<Props> = (props) => {

    const className = ClassBuilder.createClass('edit-icon')
        .addIf(props.className, props.className)
        .build();

    return (
        <EditSvgIcon className={className} onClick={props.onClick} />
    );
};

export default EditIcon;
